"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadOnlyWallet = void 0;
const web3_js_1 = require("@solana/web3.js");
class ReadOnlyWallet {
    constructor(publicKey = web3_js_1.PublicKey.default) {
        this.publicKey = publicKey;
    }
    signTransaction(_transaction) {
        throw new Error("Read only wallet cannot sign transaction.");
    }
    signAllTransactions(_transactions) {
        throw new Error("Read only wallet cannot sign transactions.");
    }
}
exports.ReadOnlyWallet = ReadOnlyWallet;
